import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../../components/statistics/downloadicon.json';

export const ButtonAnimation = props => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
    };
    
    return (
        <Lottie options={defaultOptions} 
                        height={30}
                        width={30} />
    );
};


export const ButtonComponent = ({ type = 'submit', ...props }) => {
    return (
        <button className="export-footer__button" type={type} onClick={props.onClick} disabled={props.disabled}>
            <div className="export-footer__download-icon">
                <ButtonAnimation />
            </div>
            {props.text}
        </button>
    );
};